export default __webpack_public_path__ + "../static/images/logo-maker/shapes/4.png";